import { Component, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { IOrganization, IProfile, IResponse, IUser } from '@interfaces/index';
import { ICreate } from 'projects/ui-components/src/interfaces/ICohort';
import { switchMap } from 'rxjs/operators';
import { AppService } from '@ui-components/services';
import { OrganizationService } from '../../services/organization.service';
import { OrganizationModalComponent } from '../organization-modal/organization-modal.component';

@Component({
  selector: 'app-organizations',
  templateUrl: './organizations.component.html',
  styleUrl: './organizations.component.scss'
})
export class OrganizationsComponent {

  columns = ['name', 'approval', 'edit'];
  loading = false;
  organizations: IOrganization[] = [];
  profile: IProfile | null = null;
  users: IUser[] = [];
  private destroyRef: DestroyRef;

  constructor(
    protected _app_service: AppService,
    protected _organization_service: OrganizationService,
    protected _fb: FormBuilder,
    public dialog: MatDialog,
    destroyRef: DestroyRef
  ) {
    this.destroyRef = destroyRef;
  }

  ngOnInit(): void {
    this._app_service.selectedManagementGroup$.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(() => {
      this.loadOrganizations();
    });

    this._app_service.getProfile().pipe(
      switchMap((response: IResponse<IProfile>) => {
        this.profile = response.data;
        return this._organization_service.getOrgsById(this.profile?.org_id);
      }),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((response: IResponse<IOrganization[]>) => {
      this.organizations = response.data;
    });
  }

  loadOrganizations(): void {
    if (this.profile?.org_id) {
      this.loading = true;
      this._organization_service.getOrgsById(this.profile.org_id).pipe(
        takeUntilDestroyed(this.destroyRef)
      ).subscribe((response: IResponse<IOrganization[]>) => {
        this.organizations = response.data;
        this.loading = false;
      });
    }
  }

  createOrganizationsModal(org: IOrganization | null = null): void {
    const dialog_ref = this.dialog.open(OrganizationModalComponent, {
      width: '600px',
      data: org
    });

    dialog_ref.afterClosed().pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((result: ICreate | null) => {
      if (result) {
        this.loadOrganizations();
      }
    });
  }

}
